import { type SwitchedEnvs } from "@/helpers/switch.helpers";

// TODO remove once running safely in prod NP-1397
export const excludedMigrationEnvs: SwitchedEnvs = [];

export const PORTFOLIO_OVERVIEW_MIGRATION_FEATURE_SWITCH =
  "portfolio-overview-migration";
